import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { oidcAuthApi } from './apis';
import { signInPage } from './SignInPage';

// Registers the OIDC auth apiRef + overrides the default SignInPage to
// show the "IDS SSO" provider card instead of the Guest card.
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi, signInPage],
});
